module.exports = __webpack_public_path__ + "static/images/styles/core/components/button/images/default-bg-left.b96cb06a.png";


//////////////////
// WEBPACK FOOTER
// ./styles/core/components/button/images/default-bg-left.png
// module id = 3484
// module chunks = 11